import axios from 'axios'
import { ENV } from '../Env';

export const API_URL = ENV.API_URL + '/';
export const apiVersion = 'api/v1/';

export const apiErrorCode = {
  unauthorized: 401,
  accessDenied: 430,
  sessionExpired: 423,
  validationError: 400,
  emailNotVerified: 403,
  internalError: 500
}

export const apiSuccessCode = {
  success: 200
}

export const $axios = axios.create({
  baseURL: API_URL+apiVersion,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    authorization: `Token ${localStorage.getItem('accessToken')}`
  }
})

$axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
      ? localStorage.getItem('accessToken')
      : sessionStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    } else {
      config.headers.Authorization = ''
    }
    return config
  },
  async (error) => {
    return await Promise.reject(error)
  }
)

export const $axiosForm = axios.create({
  baseURL: API_URL+apiVersion,
  timeout: 30000,
  headers: {
    'Content-Type': 'multipart/form-data',
    authorization: `Token ${localStorage.getItem('accessToken')}`
  }
})

$axiosForm.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
      ? localStorage.getItem('accessToken')
      : sessionStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    } else {
      config.headers.Authorization = ''
    }
    return config
  },
  async (error) => {
    return await Promise.reject(error)
  }
)

export function classifyOrderError(error) {
  if (axios.isCancel(error)) {
    return 'CANCELED';
  }

  if (error?.code === 'ECONNABORTED') {
    return 'TIMEOUT';
  }

  if (error?.response) {
    return 'SERVER_ERROR';
  }

  return 'NETWORK_ERROR';
}
